var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegistrationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_42691_12360",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 73,
    height: 73
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 73,
    fill: "#00A991"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_42691_12360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2374 50.4923L53.6812 29.0486L49.4228 24.7902L32.2374 41.9756L23.5687 33.3069L19.3103 37.5652L32.2374 50.4923ZM36.4958 66.9173C32.2881 66.9173 28.334 66.1188 24.6333 64.522C20.9326 62.9251 17.7135 60.7579 14.976 58.0204C12.2385 55.2829 10.0713 52.0638 8.47441 48.3631C6.87754 44.6624 6.0791 40.7083 6.0791 36.5006C6.0791 32.293 6.87754 28.3388 8.47441 24.6381C10.0713 20.9374 12.2385 17.7184 14.976 14.9809C17.7135 12.2434 20.9326 10.0762 24.6333 8.4793C28.334 6.88242 32.2881 6.08398 36.4958 6.08398C40.7034 6.08398 44.6576 6.88242 48.3582 8.4793C52.0589 10.0762 55.278 12.2434 58.0155 14.9809C60.753 17.7184 62.9202 20.9374 64.5171 24.6381C66.114 28.3388 66.9124 32.293 66.9124 36.5006C66.9124 40.7083 66.114 44.6624 64.5171 48.3631C62.9202 52.0638 60.753 55.2829 58.0155 58.0204C55.278 60.7579 52.0589 62.9251 48.3582 64.522C44.6576 66.1188 40.7034 66.9173 36.4958 66.9173ZM36.4958 60.834C43.2888 60.834 49.0426 58.4767 53.7572 53.7621C58.4718 49.0475 60.8291 43.2937 60.8291 36.5006C60.8291 29.7076 58.4718 23.9538 53.7572 19.2392C49.0426 14.5246 43.2888 12.1673 36.4958 12.1673C29.7027 12.1673 23.9489 14.5246 19.2343 19.2392C14.5197 23.9538 12.1624 29.7076 12.1624 36.5006C12.1624 43.2937 14.5197 49.0475 19.2343 53.7621C23.9489 58.4767 29.7027 60.834 36.4958 60.834Z",
    fill: "#00A991"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistrationCircle);
export default __webpack_public_path__ + "static/media/Registration_circle.ca53aeb93787524511e67e9ce1b11da9.svg";
export { ForwardRef as ReactComponent };